/* eslint-disable prettier/prettier */
import { apiService } from './api.service';
import { ApiResponse } from '../types';

export interface BulkEnrollResponse {
	successful: number;
	failed: number;
}

export interface BulkEnrollPayload {
	courseid: string;
	userids: string[];
}

export interface CoacheeListItem {
	id: string;
	fullname: string;
	email: string;
	username: string;
	profilepicture?: string | null;
	accountstatus: string;
	isactive: boolean;
	createdat: string;
	rolename: 'coachee' | 'mentee';
	activeassignments: number;
}

export interface GetCoacheesFilters {
	type: 'coachee' | 'mentee';
	unassigned?: boolean;
	search?: string;
    courseId?: string
}

class CourseBulkEnrollmentService {
	/**
	 * Bulk enroll multiple learners into a course.
	 */
	async bulkEnroll(
		courseId: string,
		userIds: string[]
	): Promise<ApiResponse<BulkEnrollResponse>> {
		try {
			const payload: BulkEnrollPayload = {
				courseid: courseId,
				userids: userIds,
			};

			const response = await apiService.post<BulkEnrollResponse>(
				'/enrollments/enrollments/bulk',
				payload
			);

			return response;
		} catch (error: any) {
			console.error('Error bulk enrolling learners:', error);

			throw error;
		}
	}

	/**
	 * Get coachees/mentees list.
	 *
	 * Can be used for:
	 * - All coachees
	 * - All mentees
	 * - Only unassigned coachees
	 * - Only unassigned mentees
	 * - Search by name/email
	 */
	async getCoacheesList(
		filters: GetCoacheesFilters
	): Promise<ApiResponse<CoacheeListItem[]>> {
		try {
			const params: Record<string, string> = {
				type: filters.type,
			};

			if (filters.unassigned !== undefined) {
				params.unassigned = String(filters.unassigned);
			}

			if (filters.search?.trim()) {
				params.search = filters.search.trim();
			}

            if (filters.courseId) {
			params.courseId = filters.courseId;
		    }

			const response = await apiService.get<CoacheeListItem[]>(
				'/user/coachees',
				params
			);

			return response;
		} catch (error: any) {
			console.error('Error fetching coachees/mentees list:', error);

			throw error;
		}
	}
}

export const courseBulkEnrollmentService = new CourseBulkEnrollmentService();